import { useEffect, useState } from 'react';
import moment from 'moment';
import { Icon, Button, Datepicker, Autocomplete } from '@a-ui/react';
import { useSelector, useDispatch } from 'react-redux'
import { getDomains, getTaskTypesForDomain, getDomainMembersForDomain } from '../../../store/slices/domainsReducer'
import { fetchTasks, setFilters } from '../../../store/slices/tasksReducer'
import { closeModal } from '../../../store/slices/modalReducer'

const postalCodes = [
  {
    label:'2000 - Antwerpen',
    value: '2000'
  },
  {
    label:'2018 - Antwerpen',
    value: '2018'
  },
  {
    label:'2020 - Antwerpen',
    value: '2020'
  },
  {
    label:'2030 - Antwerpen',
    value: '2030'
  },
  {
    label:'2040 - Berendrecht-Zandvliet-Lillo',
    value: '2040'
  },
  {
    label:'2050 - Antwerpen',
    value: '2050'
  },
  {
    label:'2060 - Antwerpen',
    value: '2060'
  },
  {
    label:'2100 - Deurne',
    value: '2100'
  },
  {
    label:'2140 - Borgerhout',
    value: '2140'
  },
  {
    label:'2150 - Borsbeek',
    value: '2150'
  },
  {
    label:'2170 - Merksem',
    value: '2170'
  },
  {
    label:'2180 - Ekeren',
    value: '2180'
  },
  {
    label:'2600 - Berchem',
    value: '2600'
  },
  {
    label:'2610 - Wilrijk',
    value: '2610'
  },
  {
    label:'2660 - Hoboken',
    value: '2660'
  }
]

const Filters = (props) => {

  const { domains, taskTypes, members } = useSelector(state => state.domains);
  const { filters } = useSelector(state => state.tasks);
  const [selectedAssignedPerson, setSelectedAssignedPerson] = useState(filters.assignedPerson);
  const [selectedAssignedPersonInputValue, setSelectedAssignedPersonInputValue] = useState(filters.assignedperson?.label ?? '')
  const [selectedTaskTypes, setSelectedTaskTypes] = useState(taskTypes.filter((taskType) => 
    filters.taskType?.value.split(',').includes(taskType?.taskType.toString())).map(t => 
      t.domainTaskTypeId.toString()
    )
  );
  const [selectedPostalCodes, setSelectedPostalCodes] = useState(postalCodes.filter((postalCode) => 
    filters.zone?.value.split(',').includes(postalCode?.value.toString())).map(t => 
      t.value.toString()
    )
  );
  const dispatch = useDispatch();
  const updateFilter = (e) => {
    let newFilterObject = { ...filters };
    const { name, value } = e.target;
    if (!value || value === null || value === "null") {
      delete newFilterObject[name];
      if(name === "domain"){
          return dispatch(setFilters({}));
      };
    } else {
      newFilterObject[name] = value;
      if (name === "plannedStartDate") {
        newFilterObject[name] = {
          value,
            operator: ">=",
          label: moment(value).format('DD/MM/yyyy'),
        }
      };
      if (name === "dueDate") {
        newFilterObject[name] = {
          value,
          operator: "<=",
          label: moment(value).subtract(2, "hours").format('DD/MM/yyyy'),
        }
      };
      if(name === "domain"){
        if (value !== "false") {
          const selectedomain = domains.find((domain) => (domain.id.toString() === value));
          dispatch(setFilters({
            domain: {
              value,
              label: selectedomain.name,
            },
          }));
          return;
        } else {
          delete newFilterObject[name];
        }
      }
    }
    dispatch(setFilters(newFilterObject));
  }
  useEffect(() => {
    dispatch(getDomains());
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    if(filters.domain?.value) {
      dispatch(getTaskTypesForDomain(filters.domain.value));
      dispatch(getDomainMembersForDomain(filters.domain.value));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters.domain]);
  useEffect(()=>{
    const selectedMember = members.find((member) => member.todoAppUser.maccount === selectedAssignedPerson);
    let newFilterObject = { ...filters };

    if(selectedMember){
      setSelectedAssignedPersonInputValue(selectedMember.todoAppUser.name)

      newFilterObject['assignedperson'] = {
        value: selectedMember.todoAppUser.maccount,
        operator: "=",
        label: selectedMember.todoAppUser.name,
      }
    }

    dispatch(setFilters(newFilterObject));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedAssignedPerson])
  useEffect(()=>{
    const selectedTaskTypeObjects = taskTypes.filter((taskType) => selectedTaskTypes.includes(taskType?.domainTaskTypeId.toString())).map(t => t.taskType);
    let value = selectedTaskTypeObjects.join(',')
    let newFilterObject = { ...filters };

    newFilterObject['taskType'] = {
        value,
        operator: "IN",
        label: value,
    }

    dispatch(setFilters(newFilterObject));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedTaskTypes])
  useEffect(()=>{
    const selectedPostalCodeObjects = postalCodes.filter((postalCode) => selectedPostalCodes.includes(postalCode?.value.toString())).map(t => t.value);
    let value = selectedPostalCodeObjects.join(',')
    let newFilterObject = { ...filters };

    newFilterObject['zone'] = {
        value,
        operator: "IN",
        label: value,
    }
    dispatch(setFilters(newFilterObject));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedPostalCodes])

  return <>
    <div className="row">
      <div className="col-xs-12 u-margin-bottom-xs">
        <div className="a-input">
          <div className="a-input has-icon-right a-input--inline u-margin-bottom flex-md">
            <label className="a-input__label a-input__label--inline" htmlFor="domain">Domein</label>
             <div className="a-input__wrapper a-input__wrapper--inline">
               <select name="domain" id="domain" onChange={updateFilter}>
                 <option value="null">Kies een domein</option>
                 { domains.map((domain) => <option selected={filters.domain?.value === domain.id.toString()} key={domain.id} value={domain.id}>{domain.name}</option>) }
                </select>
                <Icon name="ai-arrow-down-1"/>
             </div>
          </div>
          <div className="a-input has-icon-right a-input--inline u-margin-bottom flex-md">
            <label className="a-input__label a-input__label--inline" htmlFor="priority">Prioriteiten</label>
             <div className="a-input__wrapper a-input__wrapper--inline">
               <select name="priority" id="priority" value={filters.priority} onChange={updateFilter}>
                  <option value="null" >Alle prioriteiten</option>
                  <option value="true" selected={filters.priority === "true"} >Prioritair</option>
                  <option value="false" selected={filters.priority && filters.priority === "false"} >Niet prioritair</option>
                </select>
                <Icon name="ai-arrow-down-1"/>
             </div>
          </div>
          <div className="a-input has-icon-right a-input--inline u-margin-bottom flex-md">
            <label className="a-input__label a-input__label--inline" htmlFor="zone">Postcode</label>
             <div className="a-input__wrapper a-input__wrapper--inline">
             <fieldset
                style={{ border: "0", padding: 0 }}
              >
                <Autocomplete
                  items={postalCodes}
                  value={postalCodes.filter((postalCode) => filters.zone?.value?.split(',').includes(postalCode?.value.toString())).map(t => t.value.toString())}
                  multiple={true}
                  required={false}
                  onChange={setSelectedPostalCodes}
                  style={{width: 'inherit'}}
                  addOn={{
                    type: "text",
                    placement: "right",
                    content: <span>{selectedPostalCodes.length ?? 0} geselecteerd<Icon className='u-margin-left' name="ai-arrow-down-1"/></span>
                  }}
                ></Autocomplete>
              </fieldset>
             </div>
             </div>
          </div>
          <div className="a-input has-icon-right a-input--inline u-margin-bottom flex-md">
            <label className="a-input__label a-input__label--inline" htmlFor="assignedperson">Toegewezen persoon</label>
             <div className="a-input__wrapper a-input__wrapper--inline">
                <fieldset
                disabled={!filters.domain}
                style={{ border: "0", padding: 0 }}
              >
                <Autocomplete
                  items={members.filter((member) => (member.domainRole === "executor")).sort((a, b) => a.todoAppUser.name.localeCompare(b.todoAppUser.name)).map((t) => ({
                    label: t.todoAppUser.name,
                    value: t.todoAppUser.maccount,
                  }))}
                  value={filters.assignedperson?.value}
                  inputValue={selectedAssignedPersonInputValue}
                  required={false}
                  onInputChange={setSelectedAssignedPersonInputValue}
                  onChange={setSelectedAssignedPerson}                  
                  style={{width: 'inherit'}}
                  addOn={{
                    type: "icon",
                    placement: "right",
                    content: "ai-arrow-down-1"
                  }}
                ></Autocomplete>
              </fieldset>
             </div>
          </div>
          <div className="a-input has-icon-right a-input--inline u-margin-bottom flex-md">
            <label className="a-input__label a-input__label--inline" htmlFor="input-select-inline">Type taak</label>
            <div className="a-input__wrapper a-input__wrapper--inline">
            <fieldset
                disabled={!filters.domain}
                style={{ border: "0", padding: 0 }}
              >
                <Autocomplete
                  items={taskTypes.map((t) => ({
                    label: t.taskType,
                    value: t.domainTaskTypeId.toString(),
                  }))}
                  value={taskTypes.filter((taskType) => filters.taskType?.value?.split(',').includes(taskType?.taskType.toString())).map(t => t.domainTaskTypeId.toString())}
                  multiple={true}
                  required={false}
                  onChange={setSelectedTaskTypes}
                  style={{width: 'inherit'}}
                  addOn={{
                    type: "text",
                    placement: "right",
                    content: <span className={!filters.domain ? 'disabled' : ''}>{selectedTaskTypes.length ?? 0} geselecteerd<Icon className='u-margin-left' name="ai-arrow-down-1"/></span>
                  }}
                ></Autocomplete>
              </fieldset>
             </div>
          </div>
          <div className="a-input has-icon-right a-input--inline u-margin-bottom flex-md">
            <label className="a-input__label a-input__label--inline" htmlFor="input-select-inline">Geplande datum</label>
            <Datepicker
              onChange={(date, isValid) => updateFilter({ target: { name: "plannedStartDate", value: moment(date).startOf("day")}}) }
              activeDate={filters.plannedStartDate}
              selectDay={filters.plannedStartDate}
              // value={filters.plannedStartDate}
              value={ filters.plannedStartDate?.value ? moment(filters.plannedStartDate.value).format() : undefined }
            />
          </div>
          <div className="a-input has-icon-right a-input--inline u-margin-bottom flex-md">
            <label className="a-input__label a-input__label--inline" htmlFor="input-select-inline">Uiterste datum</label>
            <Datepicker
              onChange={(date, isValid) => updateFilter({ target: { name: "dueDate", value: moment(date).endOf("day").add(2, "hours") }})}
              activeDate={moment(filters.dueDate).subtract(2, "hours")}
              selectDay={moment(filters.dueDate).subtract(2, "hours")}
              value={ filters.dueDate?.value ? moment(filters.dueDate.value).subtract(2, "hours").format() : undefined }
            />
          </div>
      </div>
    </div>
    <div className="row">
      <div className="col-xs-12">
        <Button
          onClick={() => {
            dispatch(fetchTasks());
            dispatch(closeModal());
          }}
        >
          Toepassen
        </Button>
        <Button
          emphasis="low"
          onClick={() => {
            setSelectedAssignedPersonInputValue('')
            dispatch(setFilters({
            }));
            setSelectedPostalCodes([])
            setSelectedTaskTypes([])
          }}
        >
          Terugzetten
        </Button>
      </div>
    </div>
  </>

}

export default Filters;
